import React from 'react';
import { Redirect } from 'react-router-dom';

import InsuranceContractForm from '../../components/InsuranceContractForm';
import restrictedStates from '../../helpers/restictedStates';

const CreateContract = ({
  saveStatus,
  onSubmit,
  userId,
  subId,
  isAtt,
  user,
  carrier,
}) => {
  let initialValues;
  let carrierPrefix = carrier === 'sprint' ? '' : carrier;

  if (carrier === 'att') {
    initialValues = {
      att_subscription: subId,
    };
  } else if (carrier === 'quick') {
    initialValues = {
      quick_subscription: subId,
    };
  } else if (carrier === 'tracfone') {
    initialValues = {
      tracfone_subscription: subId,
    };
  } else {
    initialValues = {
      subscription: subId,
    };
  }

  if (saveStatus === 'SUCCEEDED') {
    const redirect = carrierPrefix
      ? `/${carrierPrefix}/subscriptions/${subId}/view`
      : `/subscriptions/${subId}/view`;
    return <Redirect to={redirect} />;
  }

  const isInsuranceCanBeProvided =
    user &&
    user.address &&
    user.address[0] &&
    !restrictedStates.includes(user.address[0].state);

  const transformValues = (values) => {
    let newValues = {};

    Object.keys(values).forEach((key) => {
      const fieldValue = values[key];
      if (fieldValue) {
        newValues[key] = fieldValue;
      }
    });

    return newValues;
  };

  return (
    <React.Fragment>
      <h1>Create Device Protection Contract</h1>
      <InsuranceContractForm
        saveStatus={saveStatus}
        initialValues={initialValues}
        isInsuranceCanBeProvided={isInsuranceCanBeProvided}
        onSubmit={(values) => {
          return onSubmit({
            ...transformValues(values),
            user_profile: userId,
          });
        }}
      />
    </React.Fragment>
  );
};

export default CreateContract;
